import { COREAPI } from '../constants/global';

/**
 * Best-effort backend logout for a previously-stashed token.
 *
 * Used by `useBrowserCloseLogout` on the load *after* a real browser close was
 * detected, to invalidate the server session for the token that was active when
 * the tab closed. It deliberately bypasses the Redux thunk: the stashed token
 * may differ from / outlive the current cookie (the session cookie dies on
 * close), and a logout-service hiccup must never affect the rest of the app.
 *
 * `keepalive` is harmless here (we fire from a live page, not during unload).
 * Header shape mirrors `utils.header()` (Authorization Bearer + PartyId).
 */
export const sendLogoutBeacon = (token?: string, partyId?: string) => {
	if (!token) return;
	fetch(`${COREAPI}/api/v1/Auth/logout`, {
		method: 'GET',
		keepalive: true,
		headers: {
			Authorization: `Bearer ${token}`,
			...(partyId ? { PartyId: partyId } : {}),
		},
	}).catch(() => {});
};
